<template>
    <div>
		<template>
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Retailer Whitelisting </h1>
            </div>
            <div>

                    <form @submit.prevent="insertData()" id="retailerForm">
                        <div class="tab-content-inner">
                                    <div class="form-group">
                                    <label class="label block-label"> Company <em class="required">*</em></label>
                                    <select v-model="form.company_id" data-live-search="true" name="company_id" class="form-control selectpicker custom-select2">
                                        <option value="" selected>Select Company</option>
                                        <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="company_id"></has-error>
                                     </div>
                                        <div class="form-group">
                                            <label class="label block-label"> Cities <em class="required">*</em></label>
                                            <select v-model="form.city_id" data-live-search="true" name="city_id" class="form-control selectpicker custom-select2">
                                                <option value="" selected>Select City</option>
                                                <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                                    {{ city.name }}
                                                </option>
                                            </select>
                                            <has-error :form="form" field="city_id"></has-error>
                                        </div>
                                <div class="form-group">
                                    <label class="label block-label"> Name <em class="required">*</em></label>
                                    <input v-model="form.name" type="text" name="name" class="form-control">
                                    <has-error :form="form" field="company_name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label"> Company Name <em class="required">*</em></label>
                                    <input v-model="form.company_name" type="text" name="company_name" class="form-control">
                                    <has-error :form="form" field="company_name"></has-error>
                                </div>
                                
                                <div class="form-group">
                                    <label class="label block-label"> Account No. <em class="required">*</em></label>
                                    <input v-model="form.account_no" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" name="account_no" class="form-control">
                                    <has-error :form="form" field="account_no"></has-error>
                                </div>
                            <div class="form-group">
                                <label class="label block-label"> Mobile No. <em class="required">*</em></label>
                                <input v-model="form.mobile_no" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" name="mobile_no" class="form-control">
                                <has-error :form="mobile_no" field="account_no"></has-error>
                            </div>
                                <div class="form-group">
                                    <label class="label block-label"> Email Id </label>
                                    <input v-model="form.email_id" type="email" name="email_id" class="form-control">
                                    <has-error :form="form" field="email_id"></has-error>
                                </div>
                                <div class="page-top mb-1 mb-3 clearfix" >
                                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link to="/" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                </div>


                        </div>
                    </form>

            </div>
        </template>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                companies: [],
                cities: [],
                form: new Form({
                    name: '',
                    company_id: '',
                    company_name : '',
                    mobile_no : '',
                    city_id : '',
                    email_id : '',
                    account_no : '',
                }),

            }
        },
        mounted() {
            this.$Progress.start();
            this.getCompanies();
            this.getCities();
            this.$Progress.finish();
        },
        methods: {
            insertData() {
                this.$Progress.start();
                this.form.post('/api/whitelistCompany')
                    .then(res => {
                        if(res.status == 200){
                            $('#retailerForm')[0].reset();
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            toast.fire({
                                type: 'success',
                                title: 'Record successfully added'
                            });
                            // this.$router.push('/financeLedgerReport');
                            this.$Progress.finish();
                        }else{
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.showAlertBox('error','Some problem in your form data');
                    });

            },
            getCompanies(){
                this.$Progress.start();
                axios.get('/api/getCompaniesList')
                .then(res => {
                    if(res.status == 200){
                        this.companies = res.data;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getCities(){
                this.$Progress.start();
                axios.get('/api/getCitiesList')
                    .then(res => {
                        if(res.status == 200){
                            this.cities = res.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some error in your form data');
                        }
                    }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.showAlertBox('error','Some error in your form data');
                    });
            },

        },

    }
</script>
